import { Atom, swap } from "@dbeining/react-atom";

export const accessDeniedAtom = Atom.of<boolean>(false);
export function updateAccessDeniedStateAtom(accessDenied: boolean) {
    swap(accessDeniedAtom, () => accessDenied);
}
